export const DocGenProduct = 'Document Template - Usage tracking';
export type EventMetadata = object;

export const DocumentTemplateCreateTrackEvent = 'Document Template Created';
export const DocumentTemplateEditTrackEvent = 'Document Template Edited';
export const DocumentTemplateFileUploadEvent = 'Document Template File Uploaded';
export const SignatureRequestCreatedFromDocumentTemplateTrackEvent =
	'Signature Request Created From Document Template';
export const SignatureRequestSystemFilledFieldUpdatedTrackEvent =
	'Signature Request System Filled Field Updated';

export const DOCGEN_ANALYTICS_PREFIX = 'Docgen';
const DOCGEN_FOOTER_ANALYTICS_PREFIX = `${DOCGEN_ANALYTICS_PREFIX}Footer`;
const DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX = `${DOCGEN_ANALYTICS_PREFIX}SendSignatureRequest`;
const DOCGEN_TEMPLATE_SELECTION_ANALYTICS_PREFIX = `${DOCGEN_ANALYTICS_PREFIX}TemplateSelection`;
const DOCGEN_UPLOAD_FILE_ANALYTICS_PREFIX = `${DOCGEN_ANALYTICS_PREFIX}UploadFile`;
const DOCGEN_CREATE_TEMPLATE_ANALYTICS_PREFIX = `${DOCGEN_ANALYTICS_PREFIX}CreateTemplate`;

// Footer Next Button AnalyticsId
export const FooterNextButtonAnalyticsIds = {
	StartPage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-NextButton-StartPage`,
	PreparePage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-NextButton-PreparePage`,
	ReviewPageSaveTemplate: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-SaveTemplate-ReviewPage`,
};

// Footer Previous Button AnalyticsId
export const FooterPreviousButtonAnalyticsIds = {
	PreparePage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-PreviousButton-PreparePage`,
	ReviewPage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-PreviousButton-ReviewPage`,
};

// Send Signature Request Footer Button AnalyticsId
export const SendSignatureRequestFooterAnalyticsIds = {
	NextStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddRecipientsPage`,
	NextStepReviewAndSend: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-ReviewPage`,
	PreviousStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddRecipientsPage`,
	Customize: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-CustomizeButton`,
	SendSignatureRequest: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-SendSignatureRequestButton-ReviewPage`,
	StartOver: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-StartOverButton`,
	ChangeTemplate: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-ChangeTemplateButton`,
};

// Template Selection Card AnalyticsId
export const TemplateSelectionCardAnalyticsIds = {
	Static: `${DOCGEN_TEMPLATE_SELECTION_ANALYTICS_PREFIX}-PDFTemplate`,
	Dynamic: `${DOCGEN_TEMPLATE_SELECTION_ANALYTICS_PREFIX}-EditableWordTemplate`,
};

// Upload Source AnalyticsId
export const UploadFileAnalyticsIds = {
	Computer: `${DOCGEN_UPLOAD_FILE_ANALYTICS_PREFIX}-Computer`,
	ShareFile: `${DOCGEN_UPLOAD_FILE_ANALYTICS_PREFIX}-ShareFile`,
};

// Editable Template Create Button AnalyticsId
export const EditableTemplateCreateButtonAnalyticId = `${DOCGEN_CREATE_TEMPLATE_ANALYTICS_PREFIX}-EditableTemplateCreateButton`;
